<template>
  <div class="relative">
    <div id="rain" class="absolute z-50"></div>
    <div class="rain">
      <slot></slot>
    </div>
  </div>
</template>

<script>
let rainInterval;
export default {
  name: "VueRain",
  props: {
    rainSpeed: {
      type: Number,
      default: 30,
    },
    rainFade: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      refreshRate: null,
      fade: null,
    };
  },
  mounted() {
    this.initData();
    rainInterval = setInterval(this.createRain, this.rainSpeed);
  },
  beforeDestroy() {
    clearInterval(rainInterval);
  },

  methods: {
    initData() {
      if (this.$props.rainSpeed) {
        this.refreshRate = this.rainSpeed;
      }
      if (this.$props.rainFade) {
        this.fade = this.rainFade;
      }
    },
    createRain() {
      // Using vanilla JS for DOM operations
      const rain = document.createElement("div");
      const mainRain = document.getElementById("rain");
      rain.classList.add("rain");
      rain.classList.add("text-red-700");
      rain.style.left = Math.random() * 400 + "px";
      rain.style.animationDuration = Math.random() * 2 + 3 + "s";
      rain.innerText = this.$slots.default[0].elm.innerText;
      mainRain.appendChild(rain);
      // Fade away time set
      setTimeout(() => {
        rain.remove();
      }, this.fade);
    },
  },
};
</script>

<style>
/* CSS animation class */
.rain {
  position: fixed;

  top: -1vh;
  font-size: 2rem;
  transform: translateY(0);
  animation: fall 3s linear forwards;
}

@keyframes fall {
  to {
    transform: translateY(105vh);
  }
}
</style>
